import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Paper,
  Button,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom"; // React Router for navigation
import { getTriggerActions, deleteTriggerAction } from "../../api";

const TriggerActionList = () => {
  const [actions, setActions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const fetchActions = async () => {
      const response = await getTriggerActions();
      setActions(response.data.actions);
    };

    fetchActions();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this action?")) {
      await deleteTriggerAction(id);
      setActions((prev) => prev.filter((action) => action._id !== id));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCreateTrigger = () => {
    navigate("/create-trigger-action");
  };

  return (
    <Box p={3} mx="auto">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5">Trigger Actions</Typography>
        <Button variant="contained" color="primary" onClick={handleCreateTrigger}>
          Create Trigger Action
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Condition</TableCell>
              <TableCell>Action</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {actions
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((action) => (
                <TableRow key={action._id}>
                  <TableCell>{action.name}</TableCell>
                  <TableCell>{action.description}</TableCell>
                  <TableCell>{action.conditionType}</TableCell>
                  <TableCell>{action.actionType} to {action.actionValue}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={() => handleDelete(action._id)}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={actions.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Box>
  );
};

export default TriggerActionList;
